import { Modal } from "antd";
import styled from "styled-components";

export const PrivacyPolicyModalStyle = styled(Modal)`
  /* Modal Header */
  .heading {
    font-size: 28px;
    color: #ffffff;
    margin: 0;
    padding: 0;
    font-weight: 600;
    letter-spacing: -0.5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding-bottom: 20px;
    margin-bottom: 8px;
  }

  /* Modal Mask */
  .ant-modal-mask {
    backdrop-filter: blur(8px) !important;
  }

  /* Modal Content */
  .ant-modal-content {
    backdrop-filter: blur(10px);
    color: #ffffff;
    width: 900px;
    max-width: 90vw;
    border-radius: 16px;
    margin-left: -40%;
    background: #12161f !important;
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);
  }

  /* Modal Body */
  .ant-modal-body {
    padding: 32px !important;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  /* Privacy Policy Container */
  .privacy-policy-container {
    width: 100%;
  }

  /* Scrollable Content Area */
  .privacy-policy-scroll {
    max-height: 520px;
    overflow-y: auto;
    padding-right: 16px;
    margin-right: -8px;
  }

  /* Content Wrapper */
  .privacy-policy-content {
    width: 100%;
  }

  /* Section Styling */
  .privacy-policy-section {
    padding: 24px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .privacy-policy-section:first-child {
    padding-top: 16px;
  }

  .privacy-policy-section:last-child {
    border-bottom: none;
    padding-bottom: 8px;
  }

  /* Headings - h2 (Section titles) */
  h2.PrivacyPolicyHeading {
    font-size: 20px !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    margin-bottom: 0px !important;
    letter-spacing: 0.2px;
    text-transform: none;
    font-family: 'Poppins', sans-serif !important;
  }

  /* Headings - h3 (Sub-section titles) */
  h3.PrivacyPolicyHeading {
    font-size: 15px !important;
    font-weight: 600 !important;
    color: #007aff !important;
    margin-bottom: 16px !important;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    font-family: 'Poppins', sans-serif !important;
  }

  /* Paragraphs */
  .PrivacyPolicyParam {
    font-size: 14px;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 12px;
    font-family: 'Poppins', sans-serif;
  }

  .PrivacyPolicyParam:last-child {
    margin-bottom: 0;
  }

  /* Lists */
  ul.PrivacyPolicyParam {
    padding-left: 0;
    list-style: none;
    margin-top: 12px;
  }

  ul.PrivacyPolicyParam li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 10px;
    line-height: 1.7;
  }

  ul.PrivacyPolicyParam li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    width: 6px;
    height: 6px;
    background: #007aff;
    border-radius: 50%;
  }

  ul.PrivacyPolicyParam li:last-child {
    margin-bottom: 0;
  }

  /* Strong text */
  .PrivacyPolicyParam strong {
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
  }

  /* Terms definition styling */
  .terms-definition-term {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.95);
  }

  /* Custom scrollbar for privacy content */
  .privacy-policy-scroll::-webkit-scrollbar {
    width: 6px;
  }

  .privacy-policy-scroll::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 3px;
  }

  .privacy-policy-scroll::-webkit-scrollbar-thumb {
    background: rgba(0, 122, 255, 0.4);
    border-radius: 3px;
  }

  .privacy-policy-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 122, 255, 0.6);
  }

  /* Tablet Responsive */
  @media only screen and (max-width: 768px) {
    .ant-modal-content {
      width: 95%;
      margin-left: 2.5%;
      border-radius: 12px;
    }

    .ant-modal-body {
      padding: 24px !important;
    }

    .heading {
      font-size: 22px;
      padding-bottom: 16px;
    }

    .privacy-policy-scroll {
      max-height: 400px;
    }

    h2.PrivacyPolicyHeading {
      font-size: 18px !important;
    }

    h3.PrivacyPolicyHeading {
      font-size: 14px !important;
    }

    .PrivacyPolicyParam {
      font-size: 13px;
    }

    .privacy-policy-section {
      padding: 20px 0;
    }
  }

  /* Mobile Responsive */
  @media only screen and (max-width: 600px) {
    .heading {
      font-size: 20px;
      margin: 0px;
      padding-bottom: 14px;
    }

    h2.PrivacyPolicyHeading {
      font-size: 16px !important;
      margin-bottom: 14px !important;
    }

    h3.PrivacyPolicyHeading {
      font-size: 13px !important;
      margin-bottom: 12px !important;
    }

    .PrivacyPolicyParam {
      font-size: 13px !important;
      line-height: 1.65;
    }

    .ant-modal-body {
      padding: 20px !important;
    }

    .privacy-policy-scroll {
      max-height: 350px;
      padding-right: 12px;
    }

    .privacy-policy-section {
      padding: 16px 0;
    }

    ul.PrivacyPolicyParam li {
      padding-left: 16px;
      margin-bottom: 8px;
    }

    ul.PrivacyPolicyParam li::before {
      width: 5px;
      height: 5px;
      top: 8px;
    }
  }
`;

